import OptionsViewState from './schema/OptionsViewState';
import { createStore } from 'satcheljs';
import { ObservableMap } from 'mobx';

export const getStore = createStore<OptionsViewState>('optionsViewState', {
    isFullOptionsShown: false,
    isSaving: false,
    currentCategoryKey: null,
    currentSubCategoryKey: null,
    subCategoryLoadState: new ObservableMap(),
    currentOptionKey: null,
    allowedOptions: [],
});
